//The contents of this file have been generated automatically. Do not edit this file.

import { z } from 'zod';


export const ParamsTypeZOD = z.object({
    eventId: z.string(),
});
export type ParamsType = z.TypeOf<typeof ParamsTypeZOD>;

const checkResponse = <A>(code: number, decoder: z.ZodType<A>, data: unknown): A => {
    const decodeResult = decoder.safeParse(data);
    if (decodeResult.success) {
        return decodeResult.data;
    }
    console.error('error details', {
        errors: decodeResult.error.errors,
        data
    });
    throw Error(`Response decoding error /trading/event/{event-id}/snapshot/publish -> post -> ${code}`);
};


export const Response200ZOD = z.unknown();
export type Response200Type = z.TypeOf<typeof Response200ZOD>;

export const Response400ZOD = z.string();
export type Response400Type = z.TypeOf<typeof Response400ZOD>;


const ExtraHeadersZod = z.object({
    subject: z.string().optional(),
    'pbe-user': z.string().optional(),
    'X-Forwarded-For': z.string().optional(),
    automaticTrigger: z.string().optional(),
    authorization: z.string().optional(),
});
type ExtraHeadersType = z.TypeOf<typeof ExtraHeadersZod>;


export type ApiPublishEventSnapshotParamsType = ParamsType;


export type ApiPublishEventSnapshotResponseType = 
    {
        status: 200;
        body: Response200Type;
    } | 
    {
        status: 400;
        body: Response400Type;
    };

export type ApiPublishEventSnapshotResponse200Type = Response200Type;

const convertHeaders = (params: Record<string, string | null | undefined>): Record<string, string> => {
    const result: Record<string, string> = {};

    for (const [name, value] of Object.entries(params)) {
        if (value !== null && value !== undefined) {
            result[name] = value;
        }
    }

    return result;
};

export const apiPublishEventSnapshotRequest = async (
    api_url: string,
    params: ParamsType,
    extraHeaders: ExtraHeadersType
): Promise<ApiPublishEventSnapshotResponseType> => {
    const ok = ParamsTypeZOD.safeParse(params);
    if (!ok.success) {
        console.error('Input parameters do not match the definition from openapi');
    }

    
        
    const query = '';
    const url = `${api_url}/trading/event/${params.eventId}/snapshot/publish${query}`;
    

    const headers = convertHeaders({
        'Content-Type': 'application/json; charset=utf-8',
        ...extraHeaders
    });

    const response = await fetch(url, {
        method: 'POST',
        headers,
        body: JSON.stringify(undefined),
        credentials: 'include'
    });

    const status = response.status;

    let json = null;

    try {
        const text = await response.text();
        if (text !== '') {
            json = JSON.parse(text);
        }
    } catch (_err) {
        throw Error(`Http status ${status} - json was expected`);
    }
    
    if (status === 200) {
        return { status: 200, body: checkResponse(200, Response200ZOD, json) };
    }

    if (status === 400) {
        return { status: 400, body: checkResponse(400, Response400ZOD, json) };
    }

    throw new Error(`apiPublishEventSnapshotRequest - unhandled response ${status}`);
};
